import React from "react";
import "../Styles/Pages/viewmore.scss";

const ViewMore = props => {
	function loadMore() {
		if (props.loading) {
			return;
		}
		props.load();
	}
	return (
		<div
			className="view-more-table no-print"
			style={{ margin: props.margin || "" }}
		>
			{!props.loading ? (
				<span
					className="btn btn--block btn--primary btn--crv"
					onClick={() => loadMore()}
				>
					{props.text || "View more"}
					<img src="Images/down-arrow.svg" alt="" />
				</span>
			) : (
				<div className="view-more-table-loading"></div>
			)}
		</div>
	);
};

export default ViewMore;
